<template>
  <div class="blocks-loading-dots">
    <span class="dot">.</span>
    <span class="dot">.</span>
    <span class="dot">.</span>
  </div>
</template>

<style lang="scss" scoped>
.blocks-loading-dots {
  font-size: 24px;
  display: inline-block;
  color: white;
}

.dot {
  opacity: 0;
  animation: dot-animation 2.5s infinite;

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.5s;
  }

  &:nth-child(3) {
    animation-delay: 1s;
  }
}

@keyframes dot-animation {
  0%, 100% {
    opacity: 0;
  }
  40%, 60% {
    opacity: 1;
  }
}
</style>
